module.exports = __webpack_public_path__ + "img/2020.f00cafbe.jpg";